import { Injectable } from "@angular/core";
import { MbscSelectData } from "@mobiscroll/angular";

@Injectable({
    providedIn: "root",
})
export class DiaryStateService {
    public selectedWorker: MbscSelectData | null = null;
    public selectedDate: Date = new Date();
    public viewType: "day" | "4days" | "week" = "day";
    public datepickerScrollTop: number = 0;
    public isFirstLoad: boolean = true;

    constructor() {
        this.loadInitialState();
    }

    public updateSelectedWorker(worker: MbscSelectData | null): void {
        this.selectedWorker = worker;
        this.saveState();
    }

    public updateSelectedDate(date: Date): void {
        this.selectedDate = date;
        this.saveState();
    }

    public updateViewType(viewType: "day" | "4days" | "week"): void {
        this.viewType = viewType;
        this.saveState();
    }

    public updateDatepickerScrollTop(scrollTop: number): void {
        this.datepickerScrollTop = scrollTop;
        this.saveState();
    }

    public updateIsFirstLoad(isFirst: boolean): void {
        this.isFirstLoad = isFirst;
        this.saveState();
    }

    private saveState(): void {
        const currentState = {
            selectedWorker: this.selectedWorker,
            selectedDate: this.selectedDate,
            viewType: this.viewType,
            datepickerScrollTop: this.datepickerScrollTop,
            isFirstLoad: this.isFirstLoad,
        };
        sessionStorage.setItem("diaryState", JSON.stringify(currentState));
    }

    private loadInitialState(): void {
        const savedState = sessionStorage.getItem("diaryState");

        if (savedState) {
            try {
                const parsed = JSON.parse(savedState);
                this.selectedWorker = parsed.selectedWorker || null;
                this.selectedDate = parsed.selectedDate ? new Date(parsed.selectedDate) : new Date();
                this.viewType = parsed.viewType || "day";
                this.datepickerScrollTop = parsed.datepickerScrollTop || 0;
                this.isFirstLoad = parsed.isFirstLoad !== undefined ? parsed.isFirstLoad : true;
            } catch (error) {
                console.error("Failed to parse diary state from sessionStorage:", error);
            }
        }
    }
}
